<div class="col-md-12">
  <iframe name="I1" id="if1" width="100%" height="500" style="border: 0" src="http://54.226.255.69/"></iframe>
</div>
